import { CompanyPrivacy } from '@/components/company/CompanyPrivacy';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import { Header, withLayout } from '../../components';

const Page: NextPage = () => {
  return withLayout(
    <>
      <NextSeo title="プライバシーポリシー" />
      <Header />
      <CompanyPrivacy />
    </>,
  );
};

export default Page;
